import React,{Component} from "react";
import { Card, CardBody, Form, FormInput,Button } from "shards-react";

import FileUploader from './FileUploader';

import {Form as Form1} from 'react-bootstrap';

export default class Editor extends Component{

	

	render(){
		return(

			<Card small className="mb-3">
    			<CardBody>
      				<Form className="add-new-post">
        				<FormInput size="lg" className="mb-3" placeholder="Your Post Title" onChange={(evt)=>{this.props.handleChange({title:evt.target.value})}}/>
                {
                 (this.props.photo_url===undefined) &&
                   <FileUploader update_url={this.props.changePhotoUrl}/>
        				}
                { 
                  !(this.props.photo_url===undefined) && 
                  <Button theme="danger" size="sm" onClick={this.props.remove_photo} style={{margin: '2%'}}>Remove Picture</Button>
                }
                {
                  

      				   <Form1.Group controlId="exampleForm.ControlTextarea1">
                             <Form1.Control as="textarea" rows="12" placeholder={"Description"} 
                                            onChange={(evt)=>{this.props.handleChange({description:evt.target.value})}}/>
                  </Form1.Group>

              }
              </Form>
    			</CardBody>
  				</Card>

		)
	}
}

